"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.equals = equals;
exports.insertAt = insertAt;
exports.insertSpans = insertSpans;
exports.modify = modify;
exports.moveFromTo = moveFromTo;
exports.removeAt = removeAt;
exports.replaceAt = replaceAt;
exports.unzip = unzip;
exports.zip = zip;
exports.zipWith = zipWith;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function removeAt(index, arr) {
  return [].concat(_toConsumableArray(arr.slice(0, index)), _toConsumableArray(arr.slice(index + 1)));
}

function replaceAt(index, item, arr) {
  return [].concat(_toConsumableArray(arr.slice(0, index)), [item], _toConsumableArray(arr.slice(index + 1)));
}

function insertAt(index, item, arr) {
  return [].concat(_toConsumableArray(arr.slice(0, index)), [item], _toConsumableArray(arr.slice(index)));
}

function moveFromTo(oldIndex, newIndex, arr) {
  var without = removeAt(oldIndex, arr);
  return insertAt(newIndex, arr[oldIndex], without);
}

function modify(_ref, arr) {
  var insertSpans = _ref.insertSpans,
      filterPredicate = _ref.filterPredicate;
  var sortedSpans = [];

  if (insertSpans !== undefined) {
    // no duplicated indices are allowed, ECMAScript Array.sort is not stable by spec
    var indexSet = new Set(insertSpans.map(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 1),
          i = _ref3[0];

      return i;
    }));

    if (indexSet.size !== insertSpans.length) {
      throw new Error("You cannot insert two spans at the same index. Combine the values of the spans.");
    } // sort spans by insertion position


    sortedSpans = _toConsumableArray(insertSpans);
    sortedSpans.sort(function (_ref4, _ref5) {
      var _ref6 = _slicedToArray(_ref4, 1),
          i = _ref6[0];

      var _ref7 = _slicedToArray(_ref5, 1),
          j = _ref7[0];

      return i - j;
    });
  } // The next span to insert


  var nextSpanIndex = 0; // build the new array in one pass

  var ret = [];

  for (var i = 0; i < arr.length; i += 1) {
    if (nextSpanIndex < sortedSpans.length) {
      var _sortedSpans$nextSpan = _slicedToArray(sortedSpans[nextSpanIndex], 2),
          index = _sortedSpans$nextSpan[0],
          contents = _sortedSpans$nextSpan[1];

      if (index === i) {
        ret = ret.concat(contents);
        nextSpanIndex += 1;
      }
    }

    if (filterPredicate === undefined || filterPredicate(arr[i], i, arr)) {
      ret.push(arr[i]);
    }
  } // insert spans after the end of the array


  for (var _i2 = nextSpanIndex; _i2 < sortedSpans.length; _i2 += 1) {
    var _sortedSpans$_i = _slicedToArray(sortedSpans[_i2], 2),
        _ = _sortedSpans$_i[0],
        _contents = _sortedSpans$_i[1];

    ret = ret.concat(_contents);
  }

  return ret;
}

function insertSpans(spans, arr) {
  return modify({
    insertSpans: spans
  }, arr);
} // Strict on length


function zipWith(f, left, right) {
  if (left.length !== right.length) {
    throw new Error("Tried to zip two lists of unequal length");
  }

  var ret = [];

  for (var i = 0; i < left.length; i += 1) {
    ret.push(f(left[i], right[i]));
  }

  return ret;
}

function zip(left, right) {
  return zipWith(function (l, r) {
    return [l, r];
  }, left, right);
}

function unzip(zipped) {
  var ret = [[], []];

  for (var i = 0; i < zipped.length; i += 1) {
    var _zipped$i = _slicedToArray(zipped[i], 2),
        left = _zipped$i[0],
        right = _zipped$i[1];

    ret[0].push(left);
    ret[1].push(right);
  }

  return ret;
}

function equals(a, b) {
  if (a.length !== b.length) {
    return false;
  }

  for (var i = 0; i < a.length; i++) {
    if (a[i] !== b[i]) {
      return false;
    }
  }

  return true;
}